module.exports = __webpack_public_path__ + "static/img/join_img2.67550248.png";